(function () {
	'use strict';
	$(document).ready(function () {

		const swiperProjects = new Swiper('.swiper-projects', {
			slidesPerView: 1,
			spaceBetween: 16,
			navigation: {
				prevEl: '.projects-slider .swiper-navigation .swiper-navigation-prev',
				nextEl: '.projects-slider .swiper-navigation .swiper-navigation-next'
			},
		});

		if ($('.homepage').length) {

			$('.projects-tabs-nav-item').on('click', function () {
				$(this).addClass('active').parent().siblings().children().removeClass('active');
				const projectID = $(this).data('project');
				const nonce = fhGetConfig('nonce');

				$.ajax({
					url: '/wp-admin/admin-ajax.php',
					method: 'post',
					timeout: 10000,
					data: {
						action: 'get_projects_slides',
						building_type: projectID,
						nonce: nonce,
					},
					success: function (data) {
						$('#projects-slides').empty().append(data);
						swiperProjects.update();
						swiperProjects.slideTo(0);
					},
					error: function () {
						$('.projects-ajax-info .ajax-error').slideDown();
					},
					beforeSend: function () {
						$('.projects-ajax-info .ajax-error').slideUp();
						$('.projects-ajax-info .ajax-loading').slideDown();
						$('.projects-tabs-nav').addClass('disabled');
					},
					complete: function () {
						$('.projects-ajax-info .ajax-loading').slideUp();
						$('.projects-tabs-nav').removeClass('disabled');
					},
				});
			});

		}

	});
}(jQuery));
